/**
 * @desc 自增util
 * @file util.js
 * @author dingzhenyue(dingzhenyue@baidu.com)
 */
import dayjs from 'dayjs';
import Router from '../router';
import {toast} from 'veui';
import Vue from 'vue';
import {IN_APP_PATH_REGEX} from './basePath';
Vue.use(toast);

export function dateFormat(timestamp, format) {
    // formats格式包括
    // 1. Y-m-d
    // 2. Y-m-d H:i:s
    // 3. Y年m月d日
    // 4. Y年m月d日 H时i分
    let formats = format || 'Y-m-d';

    const zero = function (value) {
        if (value < 10) {
            return '0' + value;
        }
        return value;
    };

    const myDate = timestamp ? new Date(timestamp) : new Date();

    const year = myDate.getFullYear();
    const month = zero(myDate.getMonth() + 1);
    const day = zero(myDate.getDate());

    const hour = zero(myDate.getHours());
    const minite = zero(myDate.getMinutes());
    const second = zero(myDate.getSeconds());

    return formats.replace(/Y|m|d|H|i|s/ig, function (matches) {
        return ({
            Y: year,
            m: month,
            d: day,
            H: hour,
            i: minite,
            s: second
        })[matches];
    });
}

// 过去时间的模糊处理
export function pastTimeBlur(timestamp) {
    const time = dayjs(timestamp);
    const diffMins = dayjs().diff(time, 'minutes');
    const diffDays = dayjs().startOf('day').diff(time.startOf('day'), 'days');
    if (diffMins < 1) {
        return '刚刚';
    }
    if (diffMins < 60) {
        return `${diffMins}分钟前`;
    }
    if (diffMins < 60 * 24) {
        return `${(diffMins / 60).toFixed(0)}小时前`;
    }
    if (diffDays < 2) {
        return '昨天';
    }
    if (diffDays < 3) {
        return '前天';
    }
    return time.format('YYYY.MM.DD');
}

/**
 * 多种类型跳转方法
 * @param {String} type 跳转类型：newtab等
 * @param {String} url 跳转路径
 * @returns
 */

export function pageChange({type, url}) {
    if (!url) {
        return;
    }
    switch (type) {
        case 'newtab':
            window.open(url);
            break;
        default:
            let path;
            const router = Router.getRouter();
            // 应用内路径（兼容 /fp 与 /lawyer 前缀）
            if ((path = url.match(IN_APP_PATH_REGEX)) && path[1]) {
                router.push(path[1]);
                return;
            }
            // 其他路径
            window.location.href = url;
    }
};

/**
 * 数字格式化
 *
 * @param {number} num 数字
 * @return {string} 格式化后的字符串
 */

export const formatNumEn = num => {
    num = Number(num);
    if (num >= 10000) {
        return (num / 10000).toFixed(1) + '万';
    }
    return num;
};

/**
 * 下载图片
 * @param {String} imgsrc 图片地址
 */

export const downloadImg = imgsrc => {
    // 使用fetch获取图片Blob
    fetch(imgsrc, {
        headers: new Headers({
            'Cache-Control': 'no-cache' // 防止图片渲染一次后，下次直接用缓存报跨域问题
        })
    }).then(response => {
        if (!response.ok) {
            toast.error('图片下载失败，请稍候再试');
            return;
        }
        response.blob().then(blob => {
            // 创建一个指向Blob对象的URL
            const imgUrl = URL.createObjectURL(blob);
            // 创建一个img元素并设置其src属性为Blob URL
            const a = document.createElement('a');
            a.href = imgUrl;
            // 设置下载的文件名（可选）
            a.download = 'lawyer_agent.jpg';
            // 将img元素添加到DOM中
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            // 可选：在图片加载完成后释放Blob URL
            URL.revokeObjectURL(imgUrl);
        }).catch(error => {});
    }).catch(error => {
        toast.error('图片下载失败，请稍候再试');
    });
};

// 使用正则表达式来检查字符串是否只包含空白字符
export const isOnlyWhitespace = str => {
    // ^ 表示字符串的开始，\s* 表示0个或多个空白字符，$ 表示字符串的结束
    return /^[\s]*$/.test(str);
};

export function dayTime() {
    const now = new Date();
    const h = now.getHours();
    let str;

    if (h >= 6 && h < 9) {
        str = '早安，';
    }
    else if (h >= 9 && h < 12) {
        str = '早上好，';
    }
    else if (h >= 12 && h < 14) {
        str = '中午好，';
    }
    else if (h >= 14 && h < 18) {
        str = '下午好，';
    }
    else if (h >= 18 && h < 22) {
        str = '晚上好，';
    }
    else {
        str = '夜深了，';
    }
    return str;
}

/**
 * 数字格式化
 * < 1万：显示完整数字
 * >= 1万：显示 xx.x万
 * >= 1亿：显示 xx.x亿
 * 小数末尾为0自动去掉
 */
export function formatNumber(num) {
    const value = Number(num);

    if (isNaN(value)) {
        return '-';
    }

    if (value < 10000) {
        return String(value);
    }

    const unit = value < 100000000 ? '万' : '亿';
    const divisor = value < 100000000 ? 10000 : 100000000;

    return `${(value / divisor).toFixed(1).replace(/\.0$/, '')}${unit}`;
}

export function formatExactNumber(num) {
    const value = Number(num);
    if (isNaN(value)) {
        return '-';
    }
    return value.toLocaleString('zh-CN');
}